export default __webpack_public_path__ + "static/media/plus.d97b3728.svg";